module.exports = "/images/groceries.jpg";